import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";

import MeterGuage from "../../component/score/meterGuage";
import Description from "../../component/score/description";
import NextStep from "../../component/score/nextSteps";
import EmailSection from "../../component/score/emailSection";
import ProductSolution from "../../component/score/productSolution";
import NeedHelp from "../../component/score/needHelp";

import {
  getScoreValues,
  getPDFEmailAddress,
} from "../../store/homeAction/action";
import { useStateValue } from "../../store/index";
import { useLocation } from "react-router-dom";
import SessionExpired from "../../component/score/sessionExpired";

const Score = () => {
  const [{ riskScoreData }, dispatch] = useStateValue();
  const location = useLocation();
  const { search } = location;
  const searchData = new URLSearchParams(search);
  const email = searchData.get("email");
  const [isVisible, setIsVisible] = useState(true);

  // Create refs for each section
  const nextStepRef = useRef(null);

  const sectionRefs = [nextStepRef];

  const [currentSectionIndex, setCurrentSectionIndex] = useState(1);

  useEffect(() => {
    dispatch({
      type: "SET_RISKSCORE",
      data: {},
    });
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    if (email) {
      let payload = {
        email: email,
      };
      getPDFEmailAddress((res, error) => {
        dispatch({
          type: "SET_RISKSCORE",
          data: res,
        });
        JSON.stringify(sessionStorage.setItem("mail_id", res?.email));
        sessionStorage.setItem("risk_score", JSON.stringify(res?.risk_level));
        sessionStorage.setItem(
          "qtnValues",
          JSON.stringify({
            identify_person: res?.identify_person,
            question: res?.question,
          })
        );
        sessionStorage.setItem("is_auth_mail_id", true);
        dispatch({
          type: "SET_IS_LOADING",
          value: false,
        });
        if (error) {
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: {
              severity: "error",
              message: "Something went wrong, Please try again.",
            },
          });
        }
      }, payload);
    }
    if (JSON.parse(sessionStorage.getItem("qtnValues"))?.question) {
      let payload = {
        assesment: [
          ...Object.entries(
            JSON.parse(sessionStorage.getItem("qtnValues"))?.question
          ).map(([__, answer]) => ({
            question_no: parseInt(answer?.id), // Convert question_no to integer if needed
            answer: answer?.value,
          })),
        ],
      };
      getScoreValues((res, error) => {
        dispatch({
          type: "SET_RISKSCORE",
          data: res,
        });
        sessionStorage.setItem("risk_score", JSON.stringify(res?.risk_level));
        dispatch({
          type: "SET_IS_LOADING",
          value: false,
        });
        if (error) {
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: {
              severity: "error",
              message: "Something went wrong, Please try again.",
            },
          });
        }
      }, payload);
    }

    // }
  }, []);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 1000) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // const scrollToNextSection = () => {
  //   const nextIndex = (currentSectionIndex + 1) % sectionRefs?.length;
  //   sectionRefs[nextIndex]?.current?.scrollIntoView({ behavior: "smooth" });
  //   setCurrentSectionIndex(nextIndex);
  // };

  const scrollToNextSection = () => {
    const nextIndex = (currentSectionIndex + 1) % sectionRefs.length;
    const nextSection = sectionRefs[nextIndex].current;

    if (nextSection) {
      const rect = nextSection.getBoundingClientRect();
      const scrollPosition = window.pageYOffset + rect.top - 70;

      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }

    setCurrentSectionIndex(nextIndex);
  };

  return (
    <div className="score-container">
      {riskScoreData?.expired ? (
        <SessionExpired data={riskScoreData} />
      ) : (
        <>
          <MeterGuage
            {...riskScoreData}
            isVisible={isVisible}
            scrollToNextSection={scrollToNextSection}
          />

          <div className="detailed-container">
            {riskScoreData?.what_it_mean &&
            Object.keys(riskScoreData?.what_it_mean)?.length !== 0 ? (
              <Description {...riskScoreData?.what_it_mean} />
            ) : null}
            <div className="section-container">
              {riskScoreData?.step1?.[0] &&
              Object.keys(riskScoreData?.step1?.[0])?.length !== 0 ? (
                <div ref={nextStepRef} className="next-step-container">
                  <NextStep {...riskScoreData?.step1?.[0]} />
                </div>
              ) : null}
              {riskScoreData?.step1?.[0] &&
              Object.keys(riskScoreData?.step1?.[0])?.length !== 0 ? (
                <EmailSection email_id={riskScoreData?.email} />
              ) : null}
            </div>
            {riskScoreData && Object.keys(riskScoreData)?.length !== 0 ? (
              <ProductSolution {...riskScoreData} />
            ) : null}
            {riskScoreData?.helping_section &&
            Object.keys(riskScoreData?.helping_section)?.length !== 0 ? (
              <NeedHelp {...riskScoreData?.helping_section} />
            ) : null}
          </div>
        </>
      )}
    </div>
  );
};

export default Score;
